<template>
  <div class="cont d-flex flex-column">
    <div
      class="selector-container d-flex section-container"
      :class="{ dark: skinType }"
    >
      <SectionTitle title="统计分析"></SectionTitle>
      <project-level-selector
        @selectItem="selectItemListener"
        levelType="pds"
        style="margin-right: 1rem"
      ></project-level-selector>
    </div>
    <el-row
      class="flex-grow-1 align-items-stretch"
      type="flex"
      :gutter="10"
    >
      <el-col :span="8" class="d-flex flex-column">
        <SectionContainer title="可开放容量" class="none-height flex-grow-1">
          <div class="section-content flex-grow-1 d-flex flex-column">
            <kaikefangshuju :select="select" />
          </div>
        </SectionContainer>
      </el-col>
      <el-col :span="8" class="d-flex flex-column">
        <SectionContainer title="负荷预测分析" class="none-height flex-grow-1">
          <forecasting :select="select" class="flex-grow-1" />
        </SectionContainer>
      </el-col>
      <el-col :span="8" class="d-flex flex-column">
         <SectionContainer title="变压器损耗分析" class="none-height flex-grow-1">
          <template v-slot:header>
            <el-date-picker
              style="width: 150px"
              :clearable="true"
              v-model="stockDate"
              type="date"
              placeholder="选择日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              size="mini"
              :picker-options="pickerOptions"
              @change="changes(stockDate)"
            ></el-date-picker>
          </template>
            <div
            class="section-content none-height flex-grow-1 d-flex flex-column"
          >
            <biansuohaoshuju
              :select="select"
              :notice="stockDate"
              @changes="changes"
            />
          </div>
        </SectionContainer>
      </el-col>
    </el-row>
    <el-row
      class="flex-grow-1 align-items-stretch"
      style="margin-top:12px"
      type="flex"
      :gutter="10">
      <el-col :span="24" class="d-flex flex-column">
        <SectionContainer title="变压器三相不平衡分析" class="none-height flex-grow-1">
          <div class="section-content flex-grow-1 d-flex flex-column">
            <sanxiangbupingheng :select="select" />
          </div>
        </SectionContainer>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import ProjectLevelSelector from '@/components/utils/project-level-selector.vue';
import SectionTitle from '@/components/utils/section-title.vue';
import SectionContainer from '@/components/utils/section-container.vue';
import forecasting from '../../platform/ym/forecasting.vue';
import kaikefangshuju from '../../platform/ym/kaikefangshuju.vue';
import biansuohaoshuju from '../../platform/ym/biansuohaoshuju.vue';
import sanxiangbupingheng from '../../platform/ym/sanxiangbupingheng.vue';

export default {
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      areaId: -1,
      selectLineIndex: -1,
      selectBoxIndex: -1,
      selectMeterIndex: -1,
      selectPeriod: 0,
      dateInputTypes: ['date', 'week', 'month'],
      selectDate: '',
      periods: ['日', '月', '年'],
      lines: '',
      selectLine: {},
      selectBox: {},
      selectMeter: {},
      meters: '',
      showData: '',
      // changes: "",
      time: '',
      stockDate: this.getNowTime(),
      value1: this.getNowTime(),
      value2: this.getNowTime(),
      y: [
        {
          text: '总容量',
          num: '7000kW',
          // eslint-disable-next-line global-require
          img2: require('../../../assets/images/yyimg/yuan.png'),
        },
        {
          text: '最高负荷',
          num: '7000kW',
          // eslint-disable-next-line global-require
          img2: require('../../../assets/images/yyimg/yuan.png'),
        },
        {
          text: '可开放容量',
          num: '7000kW',
          // eslint-disable-next-line global-require
          img2: require('../../../assets/images/yyimg/yuan.png'),
        },
      ],
      hy: [],
      yc: {},
      select: '',
    };
  },
  components: {
    forecasting,
    kaikefangshuju,
    biansuohaoshuju,
    ProjectLevelSelector,
    SectionTitle,
    SectionContainer,
    sanxiangbupingheng,
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    selectItemListener(node) {
      if (node.oType === 'pds') {
        this.select = node.IdStr;
      }
    },
    bianya() {
      console.log(123);
    },
    // 时间查询
    changes(stockDate) {
      console.log(stockDate);
      this.notice = stockDate;
    },
    generator(value1) {
      console.log(value1);
      this.generatrix = value1;
    },
    initData(value2) {
      console.log(value2);
      this.tricity = value2;
    },
    getNowTime() {
      const now = new Date();
      const year = now.getFullYear(); // 得到年份
      let month = now.getMonth(); // 得到月份
      let date = now.getDate(); // 得到日期
      month += 1;
      month = month.toString().padStart(2, '0');
      date = date.toString().padStart(2, '0');
      const defaultDate = `${year}-${month}-${date}`;
      console.log(defaultDate);
      return defaultDate;
    },
  },
};
</script>
<style scoped>
.section-content {
  padding: 1rem;
  display: flex;
}
.shutiao {
  width: 3px;
  height: 60%;
  background: #2e9bf3;
  margin: 0.6rem 0.5rem;
}
.btn {
  background-color: #2ea0f9;
  color: #fff;
  border: 1px solid #fff;
  border-radius: 5px;
  width: 4rem;
  height: 2.25rem;
  margin-left: 1rem;
}
.form-control {
  width: 100%;
  font-size: 0.8rem;
  /* height: calc(1.8rem + 2px); */
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  margin: 0rem 2.5rem;
}
.form-control1 {
  width: 100%;
  font-size: 0.8rem;
  height: calc(1.8rem + 2px);
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  margin: 0.5rem 0.4rem;
}
.btn {
  background-color: #2ea0f9;
  color: #fff;
  border: 1px solid #fff;
  border-radius: 5px;
  width: 4rem;
  height: 2.2rem;
  margin-left: 1rem;
  margin-top: 0.3rem;
}
.cont {
  width: 100%;
  height: 100%;
  /* background-color: salmon; */
  display: flex;
  flex-direction: column;
}
.power-item {
  width: 30%;
  height: 200%;
}
.biaoti {
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  align-items: center;
  padding-right: 1rem;
}
.fuheyucecont {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  /* background: chartreuse; */
}
.fuheshangcont {
  width: 80%;
  height: 10%;
  display: flex;
  /* align-items: center;
  justify-content: center; */
  margin-left: 2rem;
  margin-top: 1.5rem;
  /* background: chocolate; */
}
.riqishijian {
  margin-left: 1rem;
}
.fuhexiacont {
  width: 100%;
  height: 80%;
  margin-top: 2rem;
  /* background: cornflowerblue; */
}
.xiaobiaoti {
  /* border: 1px solid red; */
  height: 50%;
  flex-grow: 1;
  display: flex;
  align-items: center;
  margin: 0.6rem 0;
  font-size: 1.2rem;
}
.img1 {
  width: 5.5%;
  height: 50%;
  display: flex;
  margin: 0.8rem 2%;
  /* border:1px solid red; */
}
.biaoti5 {
  width: 100%;
  /* background-color: tomato; */
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  align-items: center;
}
.img5 {
  width: 5.7%;
  height: 50%;
  display: flex;
  margin: 0.8rem 2%;
  /* border:1px solid red; */
}
.yikuaicont {
  width: 90%;
  height: 80%;
  /* background-color: brown; */
  display: flex;
  margin: 2.5% 5%;
}
.yuanhuan {
  width: 80%;
  height: 100%;
}
.y {
  height: 35%;
  display: flex;
  margin-top: 20%;
  margin-left: 5%;
}
.zhexiantu {
  /* border: 1px solid red; */
  width: 80%;
  height: 80%;
  display: flex;
  margin: 5% 10%;
}
.sankuaicont {
  width: 90%;
  height: 90%;
  /* background-color: brown; */
  /* border: 1px solid red; */
  display: flex;
  margin: 0 1.7rem;
  margin-top: 1rem;
}
.sankuaicontzuo {
  width: 50%;
  height: 100%;
  /* background-color: burlywood; */
  display: flex;
  /* margin: 8.5% 0; */
}
.sankuaicontyou {
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* background-color: chartreuse; */
  /* margin: 8.5% 0; */
}
.shuyuanhuan {
  /* border: 1px solid red; */
  height: 45%;
  width: 50%;
  display: flex;
  margin: 7% 20%;
}
.sikuaicont {
  width: 90%;
  height: 90%;
  /* border: 1px solid red; */
  display: flex;
  /* flex-direction: column; */
  /* flex-wrap: wrap; */
  margin: 0 1.7rem;
  margin-top: 1rem;
}
.sikuaicontzuo {
  width: 50%;
  height: 100%;
  /* background-color: burlywood; */
  display: flex;
  /* margin: 8.5% 0; */
}
.sikuaicontyou {
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* background-color: chartreuse; */
  /* margin: 8.5% 0; */
}
.wukuaicont {
  width: 95%;
  height: 100%;
  /* border: 1px solid red; */
  display: flex;
  /* flex-direction: column; */
  /* flex-wrap: wrap; */ /*是否上下排列 */
  margin: 2% 2.5%;
}
.wukuaicontshang {
  width: 100%;
  height: 100%;
  /* background-color: burlywood; */
  display: flex;
  /* flex-direction: column; */
  /* margin: 8.5% 0; */
}
.wukuaicontxia {
  width: 100%;
  height: 100%;
  display: flex;
  /* flex-direction: column; */
  /* background-color: chartreuse; */
  /* margin: 8.5% 0; */
}
.wushangzuo {
  width: 95%;
  height: 100%;
  display: flex;
  /* background: chocolate; */
}
.wushangyou {
  width: 40%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* background: #d8beab; */
}
.wuxiazuo {
  width: 95%;
  height: 100%;
  display: flex;
  /* background: #c3dfc7; */
}
.wuxiayou {
  width: 40%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* background: #d4abd8; */
}
.text {
  /* border: 1px solid red; */
  font-size: 0.8rem;
}
.num {
  font-size: 0.8rem;
}
.yc {
  /* border: 1px solid blue; */
  width: 36%;
  height: 20%;
  display: flex;
  flex-direction: column;
  margin: 8% 32%;
}
.img4 {
  width: 100%;
  height: 100%;
}
.num1 {
  display: flex;
  /* border: 1px solid red; */
  margin: -50% 40%;
  font-size: 0.8rem;
}
.text1 {
  display: flex;
  /* border: 1px solid red; */
  margin: 68% 20%;
  font-size: 0.8rem;
}
.open-capacity-item {
  width: 8rem;
  height: 8rem;
}
</style>
